var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackwardStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.998 64.031C14.326 64.031 0 78.357 0 96.031V415.967C0 433.641 14.328 447.967 32.002 447.967C49.674 447.967 64 433.641 64 415.969V256V96.033C64 78.359 49.672 64.031 31.998 64.031ZM267.463 71.406L75.439 231.379C67.814 237.814 64 246.908 64 256C64 265.094 67.814 274.184 75.439 280.621L267.463 440.594C288.09 457.715 319.969 443.344 319.969 415.973V96.027C319.969 68.656 288.09 54.283 267.463 71.406Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardStep);
export default __webpack_public_path__ + "static/media/backward-step.7b7da1a1258e0c4b40d974424fd1ca61.svg";
export { ForwardRef as ReactComponent };